import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { Yii } from "libraries/interfaces/Yii";

export const PAYMENT_OPTIONS: IMultiselectOptions[] = [
    {
        value: 'card',
        label: Yii.t('wui-sasha-js', 'Carte'),
    },
    {
        value: 'cash',
        label: Yii.t('wui-sasha-js', 'Cash'),
    },
    {
        value: 'check',
        label: Yii.t('wui-sasha-js', 'Check'),
    },
    {
        value: 'invoice',
        label: Yii.t('wui-sasha-js', 'Facture'),
    },
];
